<script>
import { FallbackImageElementMixin } from "%/dynamic-component-editor/standard-elements/image-element/fallback-image-element-mixin";
import {
  FollowerCardElementMixin,
} from "%/dynamic-component-editor/standard-components/follower-card/follower-card-element-mixin";
import BaseImageElement
  from "%/dynamic-component-editor/standard-elements/image-element/BaseImageElement.vue";

export default {
  name: "FollowerOrgLogo",
  extends: BaseImageElement,
  elementPanelSettings: {
    displayName: "User Avatar",
    displayIcon: "image",
    elementGroup: "followerElements",
    elementType: "element",
  },
  mixins: [FollowerCardElementMixin, FallbackImageElementMixin],
  computed: {
    imageSrc() {
      return this.entity.logoUrl;
    },
  },
};
</script>
